import { render, staticRenderFns } from "./CategoriesSelector.vue?vue&type=template&id=b8692594"
import script from "./CategoriesSelector.vue?vue&type=script&lang=js"
export * from "./CategoriesSelector.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSelector.vue?vue&type=style&index=0&id=b8692594&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8692594')) {
      api.createRecord('b8692594', component.options)
    } else {
      api.reload('b8692594', component.options)
    }
    module.hot.accept("./CategoriesSelector.vue?vue&type=template&id=b8692594", function () {
      api.rerender('b8692594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/CategoriesSelector.vue"
export default component.exports